@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css");

/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

:root {
  --gridColumn: 12;
}

:host {
  display: block;
}


/*custom */

a,
a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

/* @media (max-width: 767.98px) {
    .card-img-top {
      height: 100%;
      
      }
    } */

    .tile-title {
    
    }
.content-padding {
  padding-bottom: 20px;
  padding-top: 20px
}

::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3;
}


/* .sect {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.sect img {vertical-align: middle;}

.sect .content {
  position: absolute;
  bottom: 0;
  background: rgb(0, 0, 0); 
  background: rgba(0, 0, 0, 0.5); 
  color: #f1f1f1;
  width: 100%;
  padding:10px;
  
} */

.card {
  background-color: transparent;
}

.top-container {
  display: grid;
  grid-template-columns: repeat(var(--gridColumn), 1fr);
  /* grid-auto-flow: column; */
  gap: 5px;

}

.top-container>div {
  /* background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 20px 0;
  font-size: 30px; */
}

.grid-item img {

  width: 100%;
  height: auto;

}

@media only screen and (max-width: 600px) {
  .top-container {
    /* grid-auto-flow: row; */
    grid-template-columns: repeat(2, 1fr);

  }

}


.bottom-left h3 {
  position: absolute;
  color: white;
  font-size: 16px;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 10px;
  margin: 0;
}

.image-first {
  margin: 0;
  position: relative;

}

.tile-title {
  font-size: 14px;
}